<router-outlet>
    <div id="spinner" #myBusyDiv style="display:''">
        <img id="busyiconid" width="100%" src="../assets/img/loader.gif" alt="Loading" />
    </div>
    <app-chat-box></app-chat-box>
</router-outlet>
